module.exports = __webpack_public_path__ + "img/partone_pic1.89e3bd4a.png";